import React from 'react';

import ProductPrice from '../Interface/ProductPrice';
import ProductCardPrice from './ProductCardPrice';
import {
  ArrowUp,
  BottomContainer,
  BottomWrapper,
  Container,
  DescriptionDiv,
  Header,
  LearnMoreButton,
  ProductCardCheckbox,
  SelectButton,
  Title,
  TitleContainer,
} from './ProductCard.style';
import { LoaderContainer } from '../LoaderSpinner';
import { colors } from '../../../theme';

export interface ProductCardProps {
  title: string;
  description: string;
  price?: ProductPrice;
  liability?: number;
  prepaid?: boolean;
  included?: boolean;
  type: 'checkbox' | 'radio';
  learnMoreAction: () => any;
  loading?: boolean;
  input: {
    name: string;
    value: string | boolean;
    checked: boolean;
    onChange: (value: string | boolean) => any;
    disabled?: boolean;
  };
}

export const ProductCard = ({
  title,
  description,
  price,
  liability,
  prepaid,
  included,
  learnMoreAction,
  type,
  loading,
  input,
}: ProductCardProps) => {
  const isUpgrade = type === 'checkbox';

  return (
    <LoaderContainer
      loading={loading}
      opacity={{ opacity: '90%', color: colors.b2cWhite }}
    >
      {isUpgrade && (
        <ArrowUp
          checked={input?.checked}
          disabled={input?.disabled}
          isUpgrade={isUpgrade}
        />
      )}
      <Container
        data-test-id={`ProductCard-${title}`}
        checked={input?.checked}
        disabled={input?.disabled}
        isUpgrade={isUpgrade}
        onClick={() =>
          !input?.disabled &&
          (isUpgrade
            ? input?.onChange(!input?.checked)
            : !input?.checked && input?.onChange(input?.value))
        }
      >
        <Header>
          <TitleContainer>
            <Title>{title}</Title>
          </TitleContainer>
          <ProductCardCheckbox
            data-test-id={`ProductCard-Checkbox-${title}`}
            isUpgrade={isUpgrade}
            disabled={input?.disabled}
            checked={input?.checked}
            type="checkbox"
            readOnly
          />
        </Header>
        <ProductCardPrice
          price={price}
          prepaid={prepaid}
          included={included}
          isUpgrade={isUpgrade}
          liability={liability}
        />
        <DescriptionDiv dangerouslySetInnerHTML={{ __html: description }} />
        <BottomContainer>
          <BottomWrapper>
            <LearnMoreButton
              target="_blank"
              onClick={(e) => {
                e.stopPropagation();
                learnMoreAction();
              }}
            >
              Learn more
            </LearnMoreButton>
            {!input?.checked ? (
              <SelectButton
                data-test-id={`ProductCard-SelectButton-${title}`}
                disabled={input?.disabled}
              >
                {isUpgrade ? 'Upgrade' : 'Select'}
              </SelectButton>
            ) : (
              isUpgrade && (
                <SelectButton
                  data-test-id={`ProductCard-SelectButton-Remove-${title}`}
                  disabled={input?.disabled}
                >
                  Remove
                </SelectButton>
              )
            )}
          </BottomWrapper>
        </BottomContainer>
      </Container>
    </LoaderContainer>
  );
};
